import React from 'react'
import ReactModal from 'react-modal'
import CloseBtn from '../../buttons/CloseBtn'
import { Form } from 'react-bootstrap'
import RequieredInputs from '../../common/RequiredInputs'

const EditPositionModal = ({
    modalIsOpen,
    closeModal,
    handleSubmit,
    inputs,
    handleChange,
    validateForm,
    textBtn
}) => {

    const customStyles = {
        content: {
            width: "60%",
        }
    }

    return (
        <ReactModal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            contentLabel="Editar cargo"
            className="custom-modal"
            ariaHideApp={false}
            style={customStyles}
        >
            <span className="custom-modal__close close-btn" onClick={closeModal}><CloseBtn /></span>
            <h4 className="custom-modal__title">Editar cargo</h4>
            <Form onSubmit={handleSubmit} className="products__form">
                <div>
                    <Form.Group controlId="product-name">
                    <Form.Label className="form__labels">Nombre <RequieredInputs/> </Form.Label>
                        <Form.Control className="user-input name"
                            type="text"
                            name="nombre"
                            value={inputs.nombre}
                            onChange={handleChange}
                            placeholder="Introduce el cargo"
                        />
                    </Form.Group>
                </div>
                <button onClick={handleSubmit} disabled={!validateForm()} className="btn save create">{textBtn}</button>
            </Form>
        </ReactModal>
    )
}

ReactModal.setAppElement('#root')
export default EditPositionModal